import { FC, useRef, useState } from 'react';
import styled from 'styled-components';

import Container from '@/components/Container/Container';
import useInterval from '@/lib/useInterval';

import Slide from './Slide';
import Switcher from './Switcher';

const slideDuration = 7384;

const Slider: FC<any> = ({ data }) => {
	const [activeSlide, changeSlideNumber] = useState<number>(0);
	const [activeSwitcher, changeActiveSwitcher] = useState<number>(0);
	const [interval, updateInterval] = useState<boolean>(true);
	const [slidingBlocked, updateSlidingBlocker] = useState<boolean>(false);
	const heroWrapperRef = useRef<any>(null);

	useInterval(
		() => {
			changeSlide(activeSlide + 1);
		},
		interval ? slideDuration : null,
	);

	const changeSlide = (slide: number) => {
		if (slidingBlocked) return;

		updateSlidingBlocker(true);

		const mobile = window.innerWidth <= 600;

		const slideWrappers = heroWrapperRef.current.children;
		const slides: any[] = [];

		for (let l = 0; l < slideWrappers.length; l++) {
			slides[l] = slideWrappers[l].children[0];
		}

		const currentSlide = activeSlide;
		const nextSlide = slide > slides?.length - 1 ? 0 : slide;

		changeActiveSwitcher(nextSlide);

		slides?.[activeSlide]?.classList?.add('hide-current-slide');
		slides?.[nextSlide]?.classList?.add('show-new-slide');

		slideWrappers?.[activeSlide]?.classList?.add('hide-current-slide');
		slideWrappers?.[nextSlide]?.classList?.add('show-new-slide');

		setTimeout(
			() => {
				changeSlideNumber(() => nextSlide);

				changeSlideNumber((upToDateSlide) => {
					slides?.[currentSlide]?.classList?.remove('hide-current-slide');
					slides?.[upToDateSlide]?.classList?.remove('show-new-slide');

					slideWrappers?.[currentSlide]?.classList?.remove(
						'hide-current-slide',
					);
					slideWrappers?.[upToDateSlide]?.classList?.remove('show-new-slide');

					return upToDateSlide;
				});
			},
			mobile ? 1010 : 1350,
		);

		setTimeout(
			() => {
				updateSlidingBlocker(false);
			},
			mobile ? 1010 : 1450,
		);
	};

	const handleClickSwithcerTab = (slide: number) => {
		changeSlide(slide);

		updateInterval(false);

		setTimeout(() => updateInterval(true), 100);
	};

	return (
		<>
			<SwitcherWrapper>
				<Container>
					<Switcher
						data={data}
						activeSlide={activeSwitcher}
						changeSlide={handleClickSwithcerTab}
					/>
				</Container>
			</SwitcherWrapper>

			<HeroWrapper ref={heroWrapperRef} className="slider-hero">
				{data?.map((slide, index) => (
					<Slide
						key={`hp_slide_${index}`}
						data={slide}
						index={index}
						activeSlide={activeSlide}
					/>
				))}
			</HeroWrapper>

			<Background />
		</>
	);
};

const SwitcherWrapper = styled.div`
	width: 100%;
	height: 100%;
	position: relative;

	@media (max-width: 900px) {
		position: absolute;
	}
	.main-container {
		position: relative;
		height: 100%;
	}
`;

const HeroWrapper = styled.div`
	height: 100vh;
	max-height: 800px;

	@media (max-width: 600px) {
		max-height: 600px;
	}

	@media (max-width: 530px) {
		height: auto;
	}
`;

const Background = styled.div`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: url('/images/bg.jpg') no-repeat center center/cover;

	@media (max-width: 767px) {
		display: none !important;
	}
`;

export default Slider;
